import Model from '@tripian/model';
import IConfig from './IConfig';

const tripianProxyURL = 'https://_kkjriasdbi34.tripian.com/';

const localConfig: IConfig = {
  name: 'local',
  NODE_ENV: process.env.NODE_ENV,

  // ALGO-TEST
  TRIPIAN_API_URL: `${tripianProxyURL}https://s6d2w4gay2.execute-api.eu-west-1.amazonaws.com/api`,
  TRIPIAN_API_KEY: 'tQTSG0UX8f9JtstGopnlvaLhuh81cWW7NTALCXR4',

  // Tripian Dev API
  // TRIPIAN_API_URL: 'https://i3btr8wa1k.execute-api.eu-west-1.amazonaws.com/api',
  // TRIPIAN_API_KEY: 'munAsYrYVw3xwKt8v9AOo2mpkTLf026U9mHSBf14',

  // Tripian TEST API
  // TRIPIAN_API_URL: 'https://8imsl0xk7d.execute-api.eu-west-1.amazonaws.com/api',
  // TRIPIAN_API_KEY: 'AOHJatyrRr4iBiJ4QW5BmlGRolcnJ215BTEpFcN0',

  // Tripian PROD API
  // TRIPIAN_API_URL: 'https://0gke6jmyse.execute-api.eu-west-1.amazonaws.com/api',
  // TRIPIAN_API_KEY: '7cq5PBc7Qd2dKkbkTP7Gj3uecDODPtof8CZ3pLNZ',

  // GOOGLE_ANALYTICS_URL: 'https://www.googletagmanager.com/gtag/js?id=UA-160871665-1',
  // GOOGLE_ANALYTICS_KEY: 'UA-160871665-1',

  SHOW_REGISTER: true,
  HIDE_OVERVIEW: true,

  STEP_CARD_THUMBS: true,
  DEMO: true,

  TOUR_PROVIDER_SOURCE: Model.PROVIDER_ID.GYG,
  TICKET_PROVIDER_SOURCE: Model.PROVIDER_ID.GYG,
};

export default localConfig;
